import React from 'react';
export const NoFleet = React.lazy(() => import('./NoFleet'));